import withDemoData from '../withDemoData'
import useApiV4 from './useAPIv4'
const useApiV4WithDemoData = withDemoData(useApiV4)

export { useApiV4, useApiV4WithDemoData }
